/** # 组装模块并导出 store 的地方 */
import { InjectionKey } from 'vue'
import { createStore, useStore as baseUseStore, Store } from 'vuex'
import products from './modules/products'
import interviewerDetail from './modules/interviewer/detail'
import cart from './modules/cart'
import { RootState } from './interfaces'
import mutations from './mutations'
import actions from './actions'

// 定义 injection key
export const key: InjectionKey<Store<RootState>> = Symbol('vuex-store')

// 定义自己的 `useStore` 组合式函数
export function useStore<T = RootState>() {
  return baseUseStore<T>(key)
}

export const store = createStore<RootState>({
  state: {
    userInfo: {
      uid: '123456',
      email: 'xxxxxxxx@qq.com'
    },
    count: 0
  },
  getters: {},
  mutations: mutations,
  actions: actions,
  modules: {
    productModule: products,
    cartModule: cart,
    detailModule: interviewerDetail
  },
  // plugins: [plugin],
  strict: process.env.NODE_ENV !== 'production'
})

// store.state.productModule // -> module-products 的状态
// store.state.cartModule // -> module-cart 的状态
